import React, { useMemo } from 'react';
import { Carousel } from '@umu/umu-design';
import { components } from 'common';
const { UMUBg, A } = components;

import { ICarrousel } from 'market/@marketCommon/interface/recommend';
import './marketCarrousel.scss';

interface IProps {
    data: ICarrousel[];
}

const CAROUSEL_ITEM_STYLE = {
    width: 1280,
    height: 460,
};

export function MarketCarrousel(props: IProps) {
    const carouselData = useMemo(() => {
        return props.data.map((item) => ({
            title: '',
            url: item.url,
            imgUrl: item.img_url,
        }));
    }, [props.data]);

    return (
        <Carousel
            autoplay
            infinite
            arrows
            accessibility
            autoplaySpeed={5000}
            speed={500}
            nextArrow={<IconArrow />}
            prevArrow={<IconArrow />}
        >
            {carouselData.map((item, index) => (
                <div className="carrousel-item" key={index + item.url} style={CAROUSEL_ITEM_STYLE}>
                    <A href={item.url} target="_blank">
                        <UMUBg clsName="carrousel-img" bgSrc={item.imgUrl} style={CAROUSEL_ITEM_STYLE} />
                    </A>
                </div>
            ))}
        </Carousel>
    );
}

function IconArrow(props: { className?: string; style?: React.CSSProperties; onClick?: VoidFunction }) {
    const { className, style, onClick } = props;
    return (
        <div className={className} style={style} onClick={onClick}>
            <i className="iconfont icon-arrow-right"></i>
        </div>
    );
}
